import { render, staticRenderFns } from "./BeginningInitialChallengeScreen.vue?vue&type=template&id=76738a45&scoped=true&"
import script from "./BeginningInitialChallengeScreen.vue?vue&type=script&lang=js&"
export * from "./BeginningInitialChallengeScreen.vue?vue&type=script&lang=js&"
import style0 from "./BeginningInitialChallengeScreen.vue?vue&type=style&index=0&id=76738a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76738a45",
  null
  
)

export default component.exports